let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fnLgR")).then(() => parcelRequire('cM06t'));